import { render, staticRenderFns } from "./MatchdayPreview.vue?vue&type=template&id=67b42e92"
import script from "./MatchdayPreview.vue?vue&type=script&lang=js"
export * from "./MatchdayPreview.vue?vue&type=script&lang=js"
import style0 from "./MatchdayPreview.vue?vue&type=style&index=0&id=67b42e92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports